import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { QueryKeys } from 'queries';
import { useIntl } from 'react-intl';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import apiService from 'services/api/ApiService';
import { SubscriptionResponse } from 'services/api/definitions/account.definitions';

export const useSubscribe = (
  options: UseMutationOptions<SubscriptionResponse, AxiosError, string> = {},
) => {
  const { enqueueSnackbar } = useSnackbar();
  const intl = useIntl();
  const queryClient = useQueryClient();

  const { mutate: subscribe, isLoading } = useMutation(
    url => apiService.proxySubscriptionEventUrl(url),
    {
      ...options,
      onSuccess: data => {
        if (data.status === 'true') {
          queryClient.invalidateQueries(QueryKeys.subscriptions.all());
        } else {
          enqueueSnackbar(intl.formatMessage({ id: 'subscriptions.activate.error' }), {
            variant: 'error',
          });
        }
      },
      onError: () => {
        enqueueSnackbar(intl.formatMessage({ id: 'subscriptions.activate.error' }), {
          variant: 'error',
        });
      },
    },
  );

  return {
    subscribe,
    isLoading,
  };
};
